module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAO1JREFUWEftlzFSwzAQRd+6SwOcwWtfCujJ0HIA4ABJC/TkUljrM4Q06azMeiCTMEMpQbFbqtB/elKhLwDjON7mnB8BBcTXCk4GTESe27Z9FzNbAi8FA3/dOue8dIAB6IA98DBN06bv+10JIDO7BK6BFbAAkgNMrt1puq57KxH8c88T69kB/E58rlT1sxKAm9h61hFAVUs/vrOzfR88AMJAGAgDYSAMhIEwEAbCwP8x8Jff8rmYAPeqWqWipZTuROQVmIvJB9DXqGbDMFw0TePVbH2sZic0NUrRWcZcTn3FzG6Ap6+SWgMkeZ6qbg77/glEyQ0p9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping-cart/checkbox-icon-0.png
// module id = x81U
// module chunks = 1